import QRCode from '~/src/common/components/QRCode/QRCode';

import { PropsFromInputs } from '../../types';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ link = '', size }: Props) => <QRCode link={link} size={size} />;
